import Color from './Color';
import Solver from './Solver';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ orgProfile: 'theme/getScoreboard' }),
    getPrimaryColour() {
      return this.orgProfile.primary || null;
    }
  },
  methods: {
    hexToRgb: function (hex) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
    },
    convertColour: function () {
      if (!this.getPrimaryColour) return null;

      const rgb = this.hexToRgb(this.getPrimaryColour);
      if (rgb.length !== 3) {
        alert('Invalid format!');
        return;
      }

      const color = new Color(rgb[0], rgb[1], rgb[2]);
      const solver = new Solver(color);
      const result = solver.solve();

      let lossMsg;
      if (result.loss < 1) {
        lossMsg = 'This is a perfect result.';
      } else if (result.loss < 5) {
        lossMsg = 'The is close enough.';
      } else if (result.loss < 15) {
        lossMsg = 'The color is somewhat off. Consider running it again.';
      } else {
        lossMsg = 'The color is extremely off. Run it again!';
      }

      return result?.filter;
    }
  }
};
